import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/home';
import Contactos from './pages/Contactos'; 
import Marmore from './pages/Marmore'; 
import Granito from './pages/Granito'; 
import './styles/style.css';
import './animation';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contacto" element={<Contactos />} />
        <Route path="/marmore" element={<Marmore />} />
        <Route path="/granito" element={<Granito />} />
      </Routes>
    </Router>
  );
};

export default App;
